// This is all the data for the cards in RecentInvestments on homepage.
// Order that properties will be displayed in carousel given by array.
// Array is .mapped over in RecentInvestments component to produce cards.

// Images for cards
import imgLakesideTownCenter from '../../assets/HP_card_lakeside_at_town.jpg';
import img1600Golf from '../../assets/HP_card_1600golf.jpg';
import imgRiverside from '../../assets/HP_card_riverside.jpg';
import imgTurtleCrossing from '../../assets/HP_card_turtle_crossing.jpg';
import imgTrailsAtLakeside from '../../assets/HP_card_trails_at_lakeside.jpg';
import imgGrandDominion from '../../assets/HP_card_grand_dominion.jpg';
import imgWalnutPlaceApartments from '../../assets/HP_card_walnut_place.jpg';
import imgWedgwoodCentre from '../../assets/HP_card_wedgwood.jpg';
import imgBrooklynPortfolio from '../../assets/HP_card_brooklyn_portfolio.jpg';


const recentInvestmentsData = [
  {
    id: 33378,
    label: 'Lakeside At Town Center',
    uuid: '0c7e0752-ad8e-495a-b21b-fa8707d49d43',
    address: {
      country: 'US',
      administrative_area: 'GA',
      locality: 'Marietta',
    },
    investmentType: 'Equity Purchase',
    propertyType: 'Multi-family',
    image: imgLakesideTownCenter,
    blurb: 'Amenities including a cyber café, fitness center, swimming pool, tennis court, playground and car wash facility surround a large stocked lake featuring a fountain and boardwalk.',
  },
  {
    id: 111210,
    label: '1600 Golf Road',
    uuid: 'c5ceaad1-da66-47d1-9f2a-0d13de023084',
    address: {
      country: 'US',
      administrative_area: 'IL',
      locality: 'Rolling Meadows',
    },
    investmentType: 'Equity Purchase',
    propertyType: 'Office',
    image: img1600Golf,
    blurb: 'A 255,440 square foot multi-tenant office building located in the Chicago region - an area supported by top universities, urban attractions, and a history of stability.',
  },
  {
    id: 208357,
    label: 'Riverside',
    uuid: 'ed53038e-663d-45ef-bb23-f4e04ea13b7b',
    address: {
      country: 'US',
      administrative_area: 'FL',
      locality: 'Jacksonville',
    },
    investmentType: 'Equity Purchase',
    propertyType: 'Multi-family',
    image: imgRiverside,
    blurb: 'A 310-unit urban-style apartment community, with amenities including a modern pool with dual aqua decks, outdoor living room, regulation-sized bocce court and two-story fitness center.',
  },
  {
    id: 212569,
    label: 'Turtle Crossing',
    uuid: '37288e5a-bca9-4e4e-98c5-53c8cd9a150d',
    address: {
      country: 'US',
      administrative_area: 'FL',
      locality: 'Coral Springs',
    },
    investmentType: 'Equity Purchase',
    propertyType: 'Retail',
    image: imgTurtleCrossing,
    blurb: 'This 99,174 square foot, institutional quality retail center includes a diversified mix of 28 national and local tenants and is shadow-anchored by a SuperTarget.',
  },
  {
    id: 213158,
    label: 'Trails at Lakeside',
    uuid: 'e8b69f9c-00fe-4849-9cc7-f5c2730433d8',
    address: {
      country: 'US',
      administrative_area: 'IN',
      locality: 'Indianapolis',
    },
    investmentType: 'Equity Purchase',
    propertyType: 'Multi-family',
    image: imgTrailsAtLakeside,
    blurb: 'This 208-unit apartment community on Indianapolis’ affluent north side is near demand drivers such as Broad Ripple Village with easy access to downtown Indianapolis.',
  },
  {
    id: 398765,
    label: 'Grand Dominion',
    uuid: 'ed53038e-663d-45ef-bb23-f4e04ea13b7b',
    address: {
      country: 'US',
      administrative_area: 'TX',
      locality: 'San Antonio',
    },
    investmentType: 'Equity Purchase',
    propertyType: 'Multi-family',
    image: imgGrandDominion,
    blurb: 'This 320-unit Class A Multifamily apartment community is located in one of the most affluent suburbs of San Antonio, boasting a resort-style pool with cabanas and a state-of-the-art fitness center.',
  },
  {
    id: 410377,
    label: 'Walnut Place Apartments',
    uuid: 'ff5ca5bf-3049-4046-b8f0-793ff228553f',
    address: {
      country: 'US',
      administrative_area: 'CA',
      locality: 'Pasadena',
    },
    investmentType: 'Equity Purchase',
    propertyType: 'Multi-family',
    image: imgWalnutPlaceApartments,
    blurb: 'In close proximity to retail amenities, public transportation and public facilities, this 28 unit property offers an individual patio or balcony for each unit and a landscaped outdoor courtyard.',
  },
  {
    id: 417363,
    label: 'Wedgwood Centre',
    uuid: '7ac22603-8c61-482d-b08c-e0c8733238d5',
    address: {
      country: 'US',
      administrative_area: 'MN',
      locality: 'Maple Grove',
    },
    investmentType: 'Equity Purchase',
    propertyType: 'Office',
    image: imgWedgwoodCentre,
    blurb: 'In the heart of highly affluent Maple Grove, Minnesota, this Institutional quality Class A midrise office building boasts efficient 20,000 SF floor plates that are attractive to users of all sizes and space layouts.',
  },
  {
    id: 420298,
    label: 'Brooklyn Portfolio',
    uuid: 'ff5ca5bf-3049-4046-b8f0-793ff228553f',
    address: {
      country: 'US',
      administrative_area: 'NY',
      locality: 'Brooklyn',
    },
    investmentType: 'Equity Purchase',
    propertyType: 'Multi-family',
    image: imgBrooklynPortfolio,
    blurb: 'Seven separate properties built between 1920 and 1935, located in various neighborhoods of Brooklyn, New York.',
  },
];

export default recentInvestmentsData;
